// @ts-nocheck
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCompanyContext } from '../context/CompanyContext';
import OverviewPage from './Overview';

/** Syncs currentAnalysisId from route :id and renders the overview workflow. */
export default function OverviewById() {
  const { id } = useParams();
  const { setCurrentAnalysisId, analyses } = useCompanyContext();

  useEffect(() => {
    if (id && analyses.some((a) => a.id === id)) {
      setCurrentAnalysisId(id);
    }
  }, [id, setCurrentAnalysisId, analyses]);

  return <OverviewPage />;
}
